import { Model } from 'pinia-orm';
import Company from './Company';


export default class RejectReason extends Model {

    static get entity () {
        return 'reject_reasons';
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.attr(null),
            order: this.attr(999),
            company_id: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            application_count: this.attr(0),
            no_title: this.attr(false),
            temp: this.boolean(false),

            //relationships
            company: this.belongsTo(Company, 'company_id'),
        }
    }
}
